import { render, staticRenderFns } from "./GoodsOdgGird.vue?vue&type=template&id=51e46c10&"
import script from "./GoodsOdgGird.vue?vue&type=script&lang=js&"
export * from "./GoodsOdgGird.vue?vue&type=script&lang=js&"
import style0 from "./GoodsOdgGird.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GoodsOdgGirdItem: require('/home/runner/work/myody_front/myody_front/components/goods/GoodsOdgGirdItem.vue').default})
